var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { EventEmitter } from "events";
import loadJs from "../common/loadjs";
import { AppJsApi } from "../common/config";
import { createDeeplink } from "../common/scheme";
import { AppDownloadStatus } from "../../../common/constants";
import Plat from "../common/plat";
import { AppInfo, AppPackage } from "../common/appInfo";
import { getApkAccessInfoFromUpage } from '../common/access';
import { debugLogger, errorLogger } from '../../debug';
var wxJsApiLitener = function (callback) {
    if (typeof self.WeixinJSBridge == "object" &&
        typeof self.WeixinJSBridge.invoke == "function") {
        callback();
    }
    else {
        if (self.document.addEventListener) {
            self.document.addEventListener("WeixinJSBridgeReady", callback, false);
        }
        else if (document.attachEvent) {
            self.document.attachEvent("WeixinJSBridgeReady", callback);
            self.document.attachEvent("onWeixinJSBridgeReady", callback);
        }
    }
};
/**
 * 处理WX的下载
 * * 部分用了TBS等能力
 */
var WXDownloader = /** @class */ (function (_super) {
    __extends(WXDownloader, _super);
    function WXDownloader(opt) {
        var _this = _super.call(this) || this;
        _this.name = 'WXDownloader';
        _this.opt = __assign({}, opt);
        _this.status = false;
        return _this;
    }
    WXDownloader.prototype.ready = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, loadJs([AppJsApi.WX, AppJsApi.TBS])];
                    case 1:
                        _a.sent();
                        this.regAdStat();
                        return [2 /*return*/];
                }
            });
        });
    };
    WXDownloader.prototype.startByAndroid = function () {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var _d, url, wxAppid, filename, iconUrl, packagename, downloadMd5, reportstring, reportstring1, reportstring2, _e, needautoinstall, rest, errorCode, accessInfo;
            var _this = this;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _d = this.opt, url = _d.url, wxAppid = _d.wxAppid, filename = _d.filename, iconUrl = _d.iconUrl, packagename = _d.packagename, downloadMd5 = _d.downloadMd5, reportstring = _d.reportstring, reportstring1 = _d.reportstring1, reportstring2 = _d.reportstring2, _e = _d.needautoinstall, needautoinstall = _e === void 0 ? true : _e, rest = __rest(_d, ["url", "wxAppid", "filename", "iconUrl", "packagename", "downloadMd5", "reportstring", "reportstring1", "reportstring2", "needautoinstall"]);
                        if (!((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.startDownload)) return [3 /*break*/, 1];
                        errorCode = window.tbs.download.startDownload(__assign({ url: url, filename: filename, iconUrl: iconUrl, needautoinstall: Boolean(needautoinstall) }, rest));
                        if (errorCode < 0) {
                            this.emit("apierror", errorCode);
                            errorLogger('异常:', 'startDownload errorCode', errorCode);
                        }
                        return [3 /*break*/, 4];
                    case 1:
                        if (!((_c = self === null || self === void 0 ? void 0 : self.WeixinJSBridge) === null || _c === void 0 ? void 0 : _c.invoke)) return [3 /*break*/, 3];
                        return [4 /*yield*/, getApkAccessInfoFromUpage(packagename)];
                    case 2:
                        accessInfo = _f.sent();
                        if (accessInfo === null || accessInfo === void 0 ? void 0 : accessInfo.privacyAgreement) {
                            self.WeixinJSBridge.invoke("addDownloadTask", {
                                task_name: filename,
                                task_url: url,
                                file_md5: downloadMd5,
                                title: filename,
                                thumb_url: iconUrl,
                                appid: wxAppid,
                                developer: accessInfo.developer,
                                app_version: accessInfo.versionName,
                                privacy_agreement_url: accessInfo.privacyAgreement,
                                permission_url: accessInfo.permissionUrl,
                            }, function (res) {
                                var _a = res.err_msg, err_msg = _a === void 0 ? "" : _a, download_id = res.download_id;
                                if (err_msg === "add_download_task:ok") {
                                    _this.download_id = download_id;
                                }
                                else if (err_msg === "add_download_task:cancel") {
                                    // 非正式事件，微信用户没有二次确认，而是直接返回了
                                    _this.emit("__giveup");
                                }
                                else {
                                    errorLogger('异常:', 'WeixinAndroidAppDownloader.download', err_msg);
                                    throw new Error("WeixinAndroidAppDownloader.download: unknown err_msg " + err_msg);
                                }
                            });
                        }
                        else {
                            errorLogger('异常:', 'WeixinAndroidAppDownloader.download', '未获取到应用信息');
                            throw new Error("WeixinAndroidAppDownloader.download: unknown err_msg " + '未获取到应用信息');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        location.href = url;
                        errorLogger('异常:', 'startDownload', '无此方法');
                        _f.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    WXDownloader.prototype.startByIos = function () {
        var appStore = this.opt.appStore;
        window.location.href = appStore;
    };
    WXDownloader.prototype.start = function () {
        if (Plat.isIos) {
            this.startByIos();
        }
        else {
            this.startByAndroid();
        }
    };
    /**
     * 补充内核统计上报
     *  type 上报的环节(0:下载开始;1:下载结束;2:安装完成)
     */
    WXDownloader.prototype.regAdStat = function () {
        var _a, _b;
        var _c = this.opt, url = _c.url, reportstring = _c.reportstring, reportstring1 = _c.reportstring1, reportstring2 = _c.reportstring2;
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.ad) === null || _b === void 0 ? void 0 : _b.reportMsgByURL) {
            window.tbs.ad.reportMsgByURL({
                appUrl: url,
                type: "0",
                reportUrl: reportstring,
            });
            window.tbs.ad.reportMsgByURL({
                appUrl: url,
                type: "1",
                reportUrl: reportstring1,
            });
            window.tbs.ad.reportMsgByURL({
                appUrl: url,
                type: "2",
                reportUrl: reportstring2,
            });
        }
        else {
            errorLogger('异常:', 'reportMsgByURL', '无此方法');
        }
    };
    WXDownloader.prototype.pause = function () {
        var _a, _b, _c;
        var url = this.opt.url;
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.pauseDownload) {
            window.tbs.download.pauseDownload({ url: url });
        }
        else if ((_c = self === null || self === void 0 ? void 0 : self.WeixinJSBridge) === null || _c === void 0 ? void 0 : _c.invoke) {
            self.WeixinJSBridge.invoke("pauseDownloadTask", {
                download_id: this.download_id,
            }, function (res) {
                var err_msg = res.err_msg;
                if (err_msg === "pause_download_task:ok") {
                }
                else {
                    throw new Error(err_msg);
                }
            });
        }
        else {
            errorLogger('异常:', 'pauseDownload', '无此方法');
        }
    };
    WXDownloader.prototype.resume = function () {
        var _a, _b, _c;
        if (Plat.isIos) {
            this.startByIos();
        }
        else {
            var url = this.opt.url;
            if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.resumeDownload) {
                window.tbs.download.resumeDownload({ url: url });
            }
            else if ((_c = self === null || self === void 0 ? void 0 : self.WeixinJSBridge) === null || _c === void 0 ? void 0 : _c.invoke) {
                self.WeixinJSBridge.invoke("resumeDownloadTask", {
                    download_id: this.download_id,
                }, function (res) {
                    var err_msg = res.err_msg;
                    if (err_msg === "resume_download_task:ok") {
                    }
                    else {
                        throw new Error(err_msg);
                    }
                });
            }
            else {
                errorLogger('异常:', 'resumeDownload', '无此方法');
            }
        }
    };
    WXDownloader.prototype.install = function () {
        var _this = this;
        var _a, _b, _c;
        if (Plat.isIos) {
            this.startByIos();
        }
        else {
            var url = this.opt.url;
            if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.installApp) {
                var errorCode = window.tbs.download.installApp({ url: url }, function (res) {
                    if (res === void 0) { res = {}; }
                    _this.emit("install", /install:/gi.test(res.ret || ""));
                });
                if (errorCode < 0) {
                    this.emit("install_error", errorCode);
                }
            }
            else if ((_c = self === null || self === void 0 ? void 0 : self.WeixinJSBridge) === null || _c === void 0 ? void 0 : _c.invoke) {
                self.WeixinJSBridge.invoke("installDownloadTask", { download_id: this.download_id, }, function (res) {
                    var installed = res.installed;
                    if (installed) {
                        _this.emit("install", installed);
                    }
                    else {
                        throw new Error("install error");
                    }
                });
            }
            else {
                this.emit("install_error");
                errorLogger('异常:', 'installApp', '无此方法');
            }
        }
    };
    WXDownloader.prototype.open = function () {
        var _a, _b, _c, _d;
        var _e = this.opt, active = _e.active, packagename = _e.packagename, wxAppid = _e.wxAppid, posId = _e.posId;
        var appID = ((_a = AppInfo[packagename]) === null || _a === void 0 ? void 0 : _a.wxAppid) || wxAppid;
        var activeUrl = active || createDeeplink(packagename);
        if (packagename === AppPackage.WX) {
            return location.href = active;
        }
        if ((_c = (_b = window === null || window === void 0 ? void 0 : window.tbs) === null || _b === void 0 ? void 0 : _b.package) === null || _c === void 0 ? void 0 : _c.runApp) {
            window.tbs.package.runApp({
                packagename: packagename,
                url: activeUrl,
                PosID: posId,
                businessType: 'ug',
            });
            debugLogger('调起APP:', 'tbs.package.runApp');
        }
        else if ((_d = self === null || self === void 0 ? void 0 : self.WeixinJSBridge) === null || _d === void 0 ? void 0 : _d.invoke) {
            self.WeixinJSBridge.invoke("launchApplication", { schemeUrl: activeUrl, appID: appID }, function (res) {
                console.log('launchApplication', res);
                window.location.href = activeUrl;
            });
            debugLogger('调起APP:', 'WeixinJSBridge');
        }
        else {
            errorLogger('异常:', 'open', '无runApp或wxjsapi');
            window.location.href = activeUrl;
        }
    };
    // 尝试探测
    WXDownloader.prototype.isInstalled = function () {
        var packagename = this.opt.packagename;
        var packageUrl = createDeeplink(packagename);
        return new Promise(function (resolve, reject) {
            wxJsApiLitener(function () {
                self.WeixinJSBridge.invoke("getInstallState", {
                    packageUrl: packageUrl,
                    packageName: packagename,
                }, function (results) {
                    var check = /get_install_state:yes/gi.test(JSON.stringify(results));
                    resolve(check);
                });
            });
        });
    };
    WXDownloader.prototype.getStatus = function () {
        var _this = this;
        var _a, _b, _c;
        var url = this.opt.url;
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.getDownloadStatus) {
            return window.tbs.download.getDownloadStatus({ url: url });
        }
        if ((_c = self === null || self === void 0 ? void 0 : self.WeixinJSBridge) === null || _c === void 0 ? void 0 : _c.invoke) {
            self.WeixinJSBridge.invoke("queryDownloadTask", { download_id: this.download_id, }, function (res) {
                var err_msg = res.err_msg, state = res.state;
                if (!err_msg) {
                    _this.emit("install", state);
                    var status_1 = {
                        download_succ: AppDownloadStatus.TASK_STATUS_COMPLETED,
                        downloading: AppDownloadStatus.TASK_STATUS_PROGRESS,
                    }[state] || AppDownloadStatus.TASK_STATUS_NONE;
                    return status_1;
                }
                errorLogger('异常:', 'runApp', '无此方法');
                return AppDownloadStatus.TASK_STATUS_NONE;
            });
        }
        else {
            return AppDownloadStatus.TASK_STATUS_NONE;
        }
    };
    WXDownloader.prototype.getProgress = function () {
        var url = this.opt.url;
        return new Promise(function (resolve, reject) {
            var _a, _b, _c, _d;
            if (((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.getDownloadFileTotalSize) && ((_d = (_c = window === null || window === void 0 ? void 0 : window.tbs) === null || _c === void 0 ? void 0 : _c.download) === null || _d === void 0 ? void 0 : _d.getDownloadProgress)) {
                var progress = 0;
                var totalSize = window.tbs.download.getDownloadFileTotalSize({ url: url });
                if (!Number.isNaN(totalSize) && Number(totalSize) !== 0) {
                    progress = Math.floor((window.tbs.download.getDownloadProgress({ url: url }) / totalSize) * 100);
                }
                resolve(progress);
            }
            else {
                resolve(0);
                errorLogger('异常:', 'getDownloadFileTotalSize/getDownloadProgress', '无此方法');
            }
        });
    };
    return WXDownloader;
}(EventEmitter));
export default WXDownloader;
